import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "changelog-badge"
}

import { ChangelogView } from '@/models/changelog'


export default /*@__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    view: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.view.unreadCount())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.view.unreadCount()), 1))
    : _createCommentVNode("", true)
}
}

})